<!-- 示波图组件中的echart逻辑 -->
<template>
  <div>
    <div :id="`multiLineChart${echartKey}`" @click.stop="closeDefault" class="multi-line-chart" ref="multiLineChart">
    </div>
  </div>
</template>
<script>

import echarts from 'echarts';
import { mapGetters } from 'vuex';

export default {
  name: 'multi-line-chart',
  props: {
    // 在当前组件中Echart的编号
    echartKey: {
      request: true,
      type: String,
    },
    // 当前组件的序号
    index: {
      type: Number,
      default: 0,
    },
    // 数据源的数据，从这个字段传入，并通过watch监听并更新
    signalData: {},
    displayStatus: {
      type: Object,
    },
    signalKeyText: {
      type: Array,
    },
    topic: {
      type: String,
    },
  },
  data() {
    return {
      // echart组件对象
      mychart: {},
      signalKeyTextObj: {},
      defaultUnit: 's',
      // 当前单位,s=秒，ms=毫秒
      unit: '',
      unitValue: 1000,
      // 刻度间隔，单位毫秒
      unitInterval: 100,
      // 刻度数量，默认30秒
      scaleLength: 30,
      // 收到一次数据更新的时间点，用于计算渲染耗时
      dataGotTime: 0,
      // 内部配置信息
      config: {
        // 单位配置
        unit: {
          ms: {
            unitStr: 'ms',
            unitInterval: 10,
            scaleLength: 30,
            unitValue: 1,
          },
          second: {
            unitStr: 's',
            unitInterval: 100,
            scaleLength: 30,
            unitValue: 1000,
          },
        },
      },
      // echart配置对象
      chartOption: {
        xAxis: {
          type: 'value',
          name: '时间',
          nameLocation: 'end',
          // data: [],
          scale: true, // 不强制包含零刻度
          minInterval: 10,
          // maxInterval: 1000, // 默认是基于秒单位的，所以是一天的秒数
          // splitNumber: 30, // 30秒分段
          axisLabel: {
            formatter: this.formatterX,
            // showMinLabel: true,
            // showMaxLabel: true,
            interval: this.xAxisLabelInterval,
          },
          boundaryGap: false,
          min: 'dataMin',
          max: 60000,
          animationDurationUpdate: 10,
        },
        yAxis: {
          type: 'value',
          axisPointer: {
            snap: true,
          },
          // boundaryGap: [0, '100%'],
        },
        dataZoom: [{
          type: 'inside',
          xAxisIndex: [0],
          // rangeMode: ['value', 'percent'],
          start: 0,
          end: 100,
          // 不过滤数据，只改变数轴范围
          filterMode: 'none',
        }],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            animation: false,
            // type: 'cross',
            // label: {
            //   backgroundColor: '#283b56',
            // },
          },
          formatter: this.tooltipsFormatter,
        },
        series: [{
          id: this.echartKey,
          name: this.signalData === undefined ? '' : this.signalData.key,
          type: 'line',
          // connectNulls: true, // 设置了很多空点，所以必须true
          clipOverflow: true,
          animation: false,
          data: [],
          showSymbol: true, // 是否显示点
          // hoverAnimation: false,
          smooth: true,
          // sampling: 'average',
          lineStyle: 1, // 线宽
        }],
      },
      // 存储太多，一次性绘制会导致内存爆炸，应设定上限
      allData: [],
    };
  },
  watch: {
    resizekey() {
      this.mychart.resize();
    },
    index: {
      handler(newIndex) {
      },
      immediate: true,
    },
    signalData: {
      handler(newData) {
        this.handlerNewData(newData);
      },
      immediate: false,
      deep: true,
    },
    displayStatus: {
      handler() {
      },
      deep: true,
    },
    getCurCmpStatus() {
      if (this.getCurCmpStatus === false) {
        this.mychart.setOption({
          xAxis: {
            min: this.chartOption.xAxis.min,
            max: this.chartOption.xAxis.max,
          },
          series: [{
            animation: false,
            data: this.allData,
          }],
        });
      } else {
        this.allData = [];
      }
    },
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    resizekey() {
      return this.$store.state.Engineering.echartResizeKey;
    },
  },
  mounted() {
    this.dataGotTime = new Date().getTime();
    const that = this;
    const dom = document.querySelector(`#multiLineChart${this.echartKey}`);
    // 初始化图表
    if (!this.topic || this.topic === 'default') {
      this.mychart = echarts.init(dom);
    } else {
      this.mychart = echarts.init(dom, this.topic);
    }
    this.changeUnit(this.defaultUnit);
    setTimeout(() => {
      this.mychart.resize();
      console.debug('resize');
    }, 2);
  },
  methods: {
    handlerNewData(newData) {
      if (this.chartOption === undefined) {
        return;
      }
      if (!newData) {
        // 重置，所有节点都是0，这样在数据来的时候，慢慢从右往左
        const data = [];
        this.chartOption.series[0].data = data;
        return;
      }
      let oldData = this.chartOption.series[0].data;
      if (oldData.length > 1000) {
        this.chartOption.series[0].data = [];
        oldData = [];
      }

      // 处理newData，添加空节点
      const { length } = newData.values;
      const { newDataIndex = 0 } = newData;
      console.debug(`新数据数量=${length - newDataIndex}`);
      for (let i = newDataIndex; i < length; i += 1) {
        const value = newData.values[i];
        const arr = [value.time, value.value];
        oldData.push(arr);
        this.allData.push(arr);
      }
      if (this.allData.length > 5000) {
        this.allData.splice(0, this.allData.length - 5000);
      }
      console.log(`总尺寸${this.allData.length}`);
      const newLength = oldData.length;
      console.debug(`length=${newLength}`);
      const lastTime = oldData[newLength - 1][0];
      if (lastTime > this.chartOption.xAxis.max) {
        this.chartOption.xAxis.max = lastTime;
      }
      this.mychart.setOption({
        xAxis: {
          min: this.chartOption.xAxis.min,
          max: this.chartOption.xAxis.max,
        },
        series: [{
          animation: false,
          data: oldData,
        }],
      });
    },
    /**
             * 根据当前的比例，格式化时间刻度
             * @param value
             * @param index 这个索引会被zoom影响，到放大时，是在屏幕内的索引，很神奇，只能用value
             * @return {*}
             */
    formatterX(value, index) {
      // console.debug(`刻度点formatter,index=${index}, value=${value}`);
      // 如果是大节点，则显示刻度
      const str = (value / this.unitValue).toFixed(2); // Number.parseInt(value / this.unitValue, 10);
      // console.debug(`刻度点formatter,index=${index}, value=${value}, result=${str}`);
      return str;
      // if (this.chartOption.xAxis.data[index].node) {
      //
      // }
      // return '';
    },

    /**
             * 间隔是否显示的判断
             * @param index 索引
             * @param value 类目名称
             */
    xAxisLabelInterval(index, value) {
      // if (this.chartOption.xAxis.data[index].node) {
      //   // console.debug(`间隔判断=true,index=${index}, value=${value}`);
      //   return true;
      // }
      // return false;
      return true;
    },
    /**
             * 悬浮时的内容格式化
             */
    tooltipsFormatter(params, ticket, callback) {
      // console.debug(params);
      // console.debug(`params.value=${params.value}`);
      const { seriesName, data } = params[0];
      const time = data[0];
      const timeStr = (time / this.unitValue).toFixed(2); // Number.parseInt(value / this.unitValue, 10);

      const value = data[1];
      return `${seriesName}<br/>value:${value}<br/>time:${timeStr}`;
    },
    /**
             * 改变当前单位，缩放时自动判断是否要调用该方法
             * @param newUnit 新的单位字符串
             */
    changeUnit(newUnit) {
      if (this.unit === newUnit) {
        return;
      }
      this.unit = newUnit;
      // 更新echart options
      const xAxis = this.chartOption.xAxis;
      if (newUnit === 's') {
        this.unitInterval = this.config.unit.second.unitInterval;
        this.scaleLength = this.config.unit.second.scaleLength;
        this.unitValue = this.config.unit.second.unitValue;
        xAxis.name = '时间(秒)';
      } else if (newUnit === 'ms') {
        this.unitInterval = this.config.unit.ms.unitInterval;
        this.scaleLength = this.config.unit.ms.scaleLength;
        this.unitValue = this.config.unit.ms.unitValue;
        xAxis.name = '时间(毫秒)';
      }
      // 更新x轴的max
      const data = this.chartOption.series[0].data;
      const length = data.length;
      let max = this.scaleLength * this.unitValue;
      if (length > 1 && data[length - 1] > max) {
        // const firstTime = Object.prototype.hasOwnProperty.call(cur, 'value') ? cur.value[0] : cur[0];
        max = data[length - 1][0];
      }
      xAxis.max = max;

      this.mychart.setOption(this.chartOption);
    },
    closeDefault() {

    },
  },
};
</script>

<style lang="scss">
  .multi-line-chart {
    width: 100%;
    height: 280px;

    & > div {
      /*width: 100% !important;*/

      & > canvas {
        width: 100% !important;
      }
    }

    &.hidden {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/echarts/SignalLineChartComponent.vue